import React from 'react';
import { Link } from 'react-router-dom';
import { apiDownloadUrl } from '../api';

const TaskListPage = () => {
  const tasks = [
    { id: 1, name: 'Đào móng', status: 'Đang làm', assignee: 'Nguyễn Văn A' },
    { id: 2, name: 'Đổ bê tông', status: 'Chưa làm', assignee: 'Trần Văn B' },
  ];
  return (
    <div>
      <h2>Danh sách công việc</h2>
      <p style={{ fontSize: 14, color: '#64748b', marginBottom: 12 }}>
        Dữ liệu thực theo đội nằm ở mục <Link to="/progress">Tiến độ</Link> (chọn dự án + đội).{' '}
        <Link to="/projects">Quản lý dự án và đội</Link>.
      </p>
      <p style={{ marginTop: 8, marginBottom: 16 }}>
        <a
          href={apiDownloadUrl('sample-tasks-template')}
          download
          style={{
            display: 'inline-block',
            padding: '8px 16px',
            background: 'linear-gradient(180deg, #2563eb 0%, #1d4ed8 100%)',
            color: '#fff',
            textDecoration: 'none',
            borderRadius: 8,
            fontWeight: 600,
            fontSize: 13,
          }}
        >
          Tải Excel mẫu import
        </a>
      </p>
      <p style={{ fontSize: 13, color: '#64748b' }}>Trang này chỉ còn bảng mẫu; import cần chọn đội trong màn Tiến độ hoặc Gantt.</p>
      <table border="1" cellPadding={8} style={{ width: '100%', marginTop: 16 }}>
        <thead>
          <tr>
            <th>Tên công việc</th>
            <th>Người phụ trách</th>
            <th>Trạng thái</th>
          </tr>
        </thead>
        <tbody>
          {tasks.map((t) => (
            <tr key={t.id}>
              <td>{t.name}</td>
              <td>{t.assignee}</td>
              <td>{t.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TaskListPage;
